import React from "react";
import { useBetaGate } from "../context/BetaGateContext";
import { useAuth } from "../context/AuthContext";
import { Lock } from "lucide-react";

/**
 * Watermark — fixed bottom-left strip stamping every page with the tester's
 * identity. Pure psychological deterrent: any screenshot is traceable to the
 * exact tester who took it.
 *
 * Layered:
 *   - Logged-in users: account email + invite code
 *   - Gate-passed only (not yet signed in): beta email + code
 *   - Outside the gate (e.g. /beta-gate itself): hidden
 *
 * Non-interactive (pointer-events: none) so it never blocks clicks.
 */
export default function Watermark() {
  const { unlocked, betaEmail, betaCode } = useBetaGate();
  const { user } = useAuth() || {};

  if (!unlocked) return null;

  const email = user?.email || betaEmail || "guest";
  const code = betaCode || "—";
  const stamp = new Date().toISOString().slice(0, 16).replace("T", " ");

  return (
    <div
      className="fixed bottom-3 left-3 z-[60] pointer-events-none select-none"
      data-testid="beta-watermark"
      aria-hidden="true"
    >
      <div
        className="flex items-center gap-2 px-3 py-1.5 font-mono-rm uppercase tracking-widest text-[10px]"
        style={{
          background: "rgba(15, 27, 45, 0.78)",
          color: "#FFC145",
          backdropFilter: "blur(6px)",
          WebkitBackdropFilter: "blur(6px)",
          border: "1px solid rgba(255, 193, 69, 0.4)",
          borderRadius: 4,
          letterSpacing: "0.1em",
        }}
      >
        <Lock size={10} className="rm-text-orange" />
        <span style={{ color: "#FF6A00", fontWeight: 700 }}>BETA</span>
        <span style={{ color: "rgba(255,255,255,0.55)" }}>·</span>
        <span>{email}</span>
        <span style={{ color: "rgba(255,255,255,0.55)" }}>·</span>
        <span style={{ color: "rgba(255,193,69,0.7)" }}>{code}</span>
        <span style={{ color: "rgba(255,255,255,0.55)" }}>·</span>
        <span style={{ color: "rgba(255,255,255,0.55)" }}>{stamp}Z</span>
      </div>
    </div>
  );
}
